export const views = [
  {
    checked: true,
    name: {
      en: 'City',
      ru: 'Город',
    },
    value: 'city',
  },
  {
    name: {
      en: 'Sandy shore',
      ru: 'Берег',
    },
    value: 'sandy',
  },
  {
    name: {
      en: 'Garden',
      ru: 'Сад',
    },
    value: 'garden',
  },
  {
    name: {
      en: 'Village',
      ru: 'Пригород',
    },
    value: 'village',
  },
  {
    name: {
      en: 'Pool',
      ru: 'Бассейн',
    },
    value: 'pool',
  },
  {
    name: {
      en: 'Town',
      ru: 'Летний город',
    },
    value: 'town',
  },
  {
    name: {
      en: 'Mountains',
      ru: 'Горы',
    },
    value: 'mountains',
  },
];
